<template>
  <v-card>
    <v-card-text>
      <v-container container--fluid grid-list-md>
         <v-row justify="space-between" align="center">
          <v-col cols="12" sm="12" md="6" v-for="(item, index) in items" :key="index">
            <v-select
              v-if="item.type === 'select'"
              :items="item.selectItems"
              :label="item.text"
              v-model="clientInfo[item.key]"></v-select>
            <v-checkbox
              v-if="item.type === 'checkbox'"
              :label="item.text"
              v-model="clientInfo[item.key]"
            ></v-checkbox>
            <v-text-field
              v-if="item.type === 'text'"
              v-model="clientInfo[item.key]"
              :label="item.text"></v-text-field>

            <v-switch
              v-if="item.type === 'switch'"
              :label="item.text"
              v-model="clientInfo[item.key]"
            ></v-switch>
          </v-col>
         </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
  // @group EditClient
  // Client Production Information tab for EditClientPage
  import axios from "axios";

  export default {
    name: "ProductionInformation",
    props: {
      // Client Object
      clientInfo: Object,
    },
    data() {
      return {
        items: [
          {text: 'Production Address', key: 'production_address', type: 'text'},
          {text: 'Production Phone', key: 'production_phone', type: 'text'},
          {
            text: 'Delivery Frequency',
            key: 'frequency',
            type: 'select',
            selectItems: ['Weekly', 'Fortnightly', 'Monthly']
          },
          {text: 'Packaging', key: 'packaging', type: 'select', selectItems: ['Cardboard', 'Polystyrene']},
          {text: 'Multiple Sizes', key: 'multiple_sizes', type: 'select', selectItems: ['Yes', 'No']},
          {text: 'Boxes per Pallet', key: 'boxes_per_pallet', type: 'text'},
          {text: 'Dimensions', key: 'dimensions', type: 'text'},
          {text: 'Weight', key: 'weight', type: 'text'},
          {text: 'Product Type', key: 'product_type', type: 'select', selectItems: ['Fresh', 'Frozen']},
          {text: 'Production Items per Box', key: 'production_items_per_box', type: 'text'},
          {text: 'Instructions on box', key: 'instruction_on_box', type: 'checkbox'},
          {text: 'Data Validation', key: 'data_validation', type: 'checkbox'},
          {text: 'Pick Pack', key: 'pick_pack', type: 'switch'}
        ]

      }
    },
    methods:{

    },


    computed: {

    },
    asyncComputed: {

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/util/Clients/ProductionInformation.vue